import Vue from 'vue'

/**
 * Sort plain or objects array by date filter
 * @name SortByDate Utils filter
 * @returns {array} Date sorted Array
 */

const sortByDate = (arrayToSort, sortByKey, orderBy = 'asc') => {

  const orientation = orderBy === 'asc' ? 1 : -1

  const isSortable = Array.isArray(arrayToSort)
  const plainStrArray = isSortable && arrayToSort.every((element) => typeof element === 'string')

  if (!isSortable || (!plainStrArray && !sortByKey)) {
    console.warn('[sort-date-filter] Unable to sort provided source')

    return arrayToSort
  }

  function laterThan(d1, d2) {
    const timestampToTest = Math.round(new Date(d1).getTime() * 1000)
    const timestampRef = Math.round(new Date(d2).getTime() * 1000)

    return timestampToTest > timestampRef
  }

  return arrayToSort.sort((a, b) => {
    const aVal = plainStrArray ? a : a[sortByKey] || ''
    const bVal = plainStrArray ? b : b[sortByKey] || ''

    if (aVal === bVal) {
      return 0
    }

    return (laterThan(aVal, bVal) ? 1 : -1) * orientation
  })
}

Vue.filter('sortByDate', sortByDate)

export default sortByDate
